// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"552":"aaec5d28","648":"aa59c0bc","965":"e4147ca2"}[chunkId] + ".chunk.css";
};